import Cart from "./cart";

export default class Order extends Cart{
  orderNumber: string;
  orderDate: string;
  shippingInfo: any;
  customerEmail: string;
  cartId: string;

  constructor(order: any = {}) {
    super(order);
    this.cartId = order?.cart?.id;
    this.orderNumber = order.orderNumber;
    this.orderDate = order.orderDate;
    this.shippingInfo = order.shippingInfo;
    this.customerEmail = order.customerEmail;
  }
}
